import { render, staticRenderFns } from "./SchoolAdd.vue?vue&type=template&id=3a73400e&"
import script from "./SchoolAdd.vue?vue&type=script&lang=js&"
export * from "./SchoolAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports